import { render } from "./login.vue?vue&type=template&id=2869edfe&scoped=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=2869edfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2869edfe"

export default script